import FroalaEditor from 'froala-editor';

const FE = FroalaEditor && FroalaEditor.hasOwnProperty('default') ? FroalaEditor['default'] : FroalaEditor;

FE.SHORTCUTS_MAP['222'].letter = 'ä';
FE.SHORTCUTS_MAP['^222'].letter = 'ä';

FE.LANGUAGE['de'].translation = Object.assign({}, FE.LANGUAGE['de'].translation, {
    'Table Footer': 'Tabelle Fußzeile',
    'Highlighted': 'Hervorgehoben',
    'Thick': 'Fett',
    'Image cannot be loaded from the passed link.': 'Das Bild kann nicht von dem übergebenen Link geladen werden.',
    'Ctrl': 'Strg',
    'Rounded': 'Abgerundet',
    'Bordered': 'Eingerahmt',
    'Shadow': 'Schatten',
    'Green': 'Grün',
});